<template>
  <div></div>
</template>

<script setup>
// npm install devtools-detector --legacy-peer-deps
import { router } from "@/plugins/1.router";
import { addListener, launch } from "devtools-detector";
import { onMounted, onUnmounted } from "vue";

// ✅ Sadece production modda çalışsın
const isProduction = import.meta.env.MODE === "production";
// const isProduction = true;

// 'onUnmounted' içinde kullanmak üzere 'unsubscribe' fonksiyonunu tutacak değişken
let unsubscribe = null;

/**
 * Geliştirici araçları tespit edildiğinde gösterilecek overlay ve yönlendirme.
 * (Bu fonksiyon sizin kodunuz, hiç değiştirmedim.)
 */
function handleDevtoolsOpen() {
  // Overlay'in tekrar tekrar eklenmesini engelle
  if (document.getElementById("devtools-overlay")) {
    return;
  }

  const style = `
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 100%;
    background: #000;
    color: #0f0;
    font-family: monospace;
    font-size: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    white-space: pre-wrap;
    text-align: left;
    padding: 10px;
  `;

  const message = `
AygulYazilim Opss Sistemleri

Geliştirici Modu Tespit edildi!

Geliştirici araçına mı girdin? 😏
Kodlar korktu ve kendini imha etti! 💥
Giriş sayfasına yönlendiriliyorsun...
`;

  const overlay = document.createElement("div");
  overlay.setAttribute("id", "devtools-overlay"); // ID ekle
  overlay.setAttribute("style", style);
  overlay.textContent = message;
  document.body.appendChild(overlay);

  router.push({ name: "login" });
}

onMounted(() => {
  if (isProduction) {
    // 1. Sağ menü engelleme
    document.addEventListener("contextmenu", (e) => e.preventDefault());

    // 2. DevTools Detektörünü Başlat

    // addListener, listener'ı kaldırmak için bir fonksiyon döndürür.
    // Bunu 'onUnmounted'da çağırmak için 'unsubscribe' değişkenine atıyoruz.
    unsubscribe = addListener((isOpen) => {
      // Hata veren 'view.innerText' satırı yerine:
      if (isOpen) {
        handleDevtoolsOpen();
      }
    });

    // Tespiti başlat
    launch();
  }
});

onUnmounted(() => {
  // 3. Component kaldırıldığında (yok edildiğinde) listener'ı temizle
  // 'detector.stop()' yerine 'unsubscribe()' fonksiyonunu çağır
  if (unsubscribe) {
    unsubscribe();
  }
});
</script>
